import { GeoJSONSource, Map } from "mapbox-gl"
import { Landplot } from "./organisation/Landplot"

function getPolygons(plots: Landplot[]): any {

    const features = []
    plots?.filter(p => p?.polygon?.coordinates).forEach(p => {
        features.push({
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": p.polygon.coordinates
            },
            "properties": {
            }
        })
    })

    return {
        "type": "FeatureCollection",
        "features": features
    }
}

export function updatePolygonGroup(map: Map, plots: Landplot[]) {
    if (map.getSource("polygons")) {
        var json = getPolygons(plots);
        (map.getSource("polygons") as GeoJSONSource).setData(json);    
    }
}

export function addPolygonGroupFeature(map: Map, plots: Landplot[]) {
    map.addSource("polygons", {
        "type": "geojson",
        "data": getPolygons(plots)
    })

    map.addLayer({
        "id": "millCircle",
        "type": "fill",
        "source": "polygons",
        "layout": {},
        "paint": {
            "fill-color": "blue",
            "fill-opacity": 0.2
        }
    });
    map.addLayer({
        "id": "millLine",
        "type": "line",
        "source": "polygons",
        "layout": {},
        "paint": {
            "line-color": "blue",
            "line-width": 3
        }
    });
}
